
window.formatDate = function(date,format,withTime){
	if(withTime === null){
		withTime = true;
	}
    let now  = moment();
	if(typeof date != "object"){
		date = moment(date);
	}
	if(!format){

		format = window.translate('momentDateFormat.fullDay');
		if(withTime){
			format = window.translate('momentDateFormat.fullDayTime');
		}

	    if(now.format('DDMMYYYY') == date.format('DDMMYYYY')){
	    	//same day
			format = window.translate('momentDateFormat.time');
	    }else if(now.format('MMYYYY') == date.format('MMYYYY')){
	    	//same month
	    	format = window.translate('momentDateFormat.monthDay');
			if(withTime){
				format = window.translate('momentDateFormat.monthDayTime');
			}
	    }else if(now.format('YYYY') == date.format('YYYY')){
	    	//same yearformat = window.translate('momentDateFormat.fullDay');
	    	format = window.translate('momentDateFormat.monthDay');
			if(withTime){
				format = window.translate('momentDateFormat.monthDayTime');
			}
    	}
    }
    return date.format(format);
}

window.ensureFloatText = function(value){
	if(typeof value == 'string'){
		value = value.replace(',','.');
	}
	return value;
}

window.formatFloat = function(value,decimals,separator){
	if(!decimals){
		decimals = 2;
	}
	if(!separator){
		separator = ',';
	}
	if(value === null){
		value = 0;
	}
	value = window.ensureFloatText(value);
	value =  parseFloat(value);
	if(isNaN(value)){
		value = 0;
	}
	if(separator == ','){
		//return value.toLocaleString('fr',{'maximumFractionDigits': decimals});
	}

	value =  value.toFixed(decimals);
	let zeros = '';
	for(var i=0;i<decimals;i++){
		zeros+='0';
	}
	value = value.replace('.'+zeros,'');
	return value.replace('.',separator);
}

window.stringifyObject = function(param){
    if(Array.isArray(param)){ // In case of an array, recursively call our function on each element.
        let results = [];
        for(let elem of param){
            results.push(stringifyObject(elem));
        }
        return "[" + results.join(",") + "]";
    }
    else if(typeof param === "object"){ // In case of an object, loop over its keys and only add quotes around keys that aren't valid JavaScript variable names. Recursively call our function on each value.
        let props = Object
            .keys(param)
            .map(function(key){
                // A valid JavaScript variable name starts with a dollar sign (?), underscore (_) or letter (a-zA-Z), followed by zero or more dollar signs, underscores or alphanumeric (a-zA-Z\d) characters.
                if(key.match(/^[a-zA-Z_$][a-zA-Z\d_$]*$/) === null) // If the key isn't a valid JavaScript variable name, we need to add quotes.
                    return `"${key}":${stringifyObject(param[key])}`;
                else
                    return `${key}:${stringifyObject(param[key])}`;
            })
            .join(",");
        return `{${props}}`;
    }
    else{ // For every other value, simply use the native JSON.stringify() function.
        return JSON.stringify(param);
    }
}

window.refresh = function(millisecondsToWait){
	if(millisecondsToWait === null) millisecondsToWait = 'now';

	if(millisecondsToWait && Number.isInteger(millisecondsToWait) && millisecondsToWait > 0){
		setTimeout(
			function(){ 
				window.refresh('now');
			},
			millisecondsToWait
		);
	}else{
		window.location.reload();
	}
}

window.redirect = function(url,millisecondsToWait){
	if(millisecondsToWait === null) millisecondsToWait = 'now';

	if(millisecondsToWait && Number.isInteger(millisecondsToWait) && millisecondsToWait > 0){
		setTimeout(
			function(){ 
				window.redirect(url,'now');
			},
			millisecondsToWait
		);
	}else{
		window.location.href = url;
	}
}

window.uniqid = function(separator='-'){
	function chr4(){
		return Math.random().toString(16).slice(-4);
	}

	var id = 'uniqid' + chr4() + chr4() +
	separator + chr4() +
	separator + chr4() +
	separator + chr4() +
	separator + chr4() + chr4() + chr4();
	
	if($('#'+id).length > 0){
		return window.uniqid();
	}
	return id;
}

window.replaceTagName = function($source,newTag){
	var $newElement = $('<'+newTag+'/>');

	//content
	var content = $source.html();
	$newElement.append(content);


	//attributes
	var sourceAttributes = $source[0].attributes;
	var attributes = [
		'id','name','class','style','data-.*'
	];

	for(var i in attributes){
		var attr = attributes[i];
		var regex = new RegExp('^'+attr+'$');
		for(var j in sourceAttributes){

			var sourceAttr = sourceAttributes[j];

			if(regex.test(sourceAttr.name)){
				$newElement.attr(sourceAttr.name,sourceAttr.value);
			}
		}
	}

	//events
	var events = $source[0].events;	
    $.each(events, function(eventType, eventArray) {
        $.each(eventArray, function(index, event) {
			var eventToBind = event.namespace.length > 0 ? (event.type + '.' + event.namespace) : (event.type);
			$newElement.bind(eventToBind, event.data, event.handler);
        })
    });

	return $newElement;
}

window.uncacheFile = function(path,callback){
	if(callback === null){
		callback = function(){};
	}

	var headers = new Headers()
	headers.append('pragma', 'no-cache')
	headers.append('cache-control', 'no-cache')
	var init = {
		method: 'GET',
		headers: headers,
		mode: 'no-cors',
		cache: 'no-cache',
	}
	fetch(new Request(path), init)
	.then(callback);

}

window.notify = function(message,level,data,delay){
	if( window.FFSS){
		return window.FFSS.notify(message,level,data,delay);
	}else{
		switch(level){
			case 'error':
			case 'danger':
				console.error(message,data);
			break;
			default:
				console.log(message,data);
			break;
		}
	}
}

window.isHtml = function(str) {
  var doc = new DOMParser().parseFromString(str, "text/html");
  return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
}

window.isUrl = function(str){
	try { return Boolean(new URL(str)); }
	catch(e){ return false; }	
}

window.isNumeric = function(value) {
    return /^-?\d+$/.test(value);
}

window.basename = function(path){
	let separator = '/';
	const windowsSeparator = '\\';
	if (path.includes(windowsSeparator)) {
		separator = windowsSeparator;
	}
	return path.slice(path.lastIndexOf(separator) + 1)
}

window.inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

window.isString = function(variable){
	if (typeof variable === 'string' || variable instanceof String){
		return true;
	}
	return false;
}

window.ellipseText = function(text, max){
	let $text = $(text);
	text = $text.text();
	if(!window.isString(text)){
		return text;
	}
	if(!max){
		max = 100;
	}
	if(text.length <= max){
		return text;
	}
    return text.substr(0,max-1)+(text.length>max?'&hellip;':''); 
}

Object.defineProperty(String.prototype, 'capitalize', {
  value: function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});


window.onGoogleMapApiLoaded = function(){
	window.FFSS.onGoogleMapApiLoaded();
};

window.scrollToElement = function($element){
	$('html, body').animate({
		'scrollTop': ($element.offset().top - 10)
	}, 500);
}